// extracted by mini-css-extract-plugin
export default {"groupChild":"R08u7TPSX_2N58ogVT18","fullWidth":"AvrtS2GmjWUV06LbZRxe"};